module.exports = __webpack_public_path__ + "static/img/celoscope-detail-14.cebe0dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-14.jpg
// module id = of7J
// module chunks = 51